module.exports = __webpack_public_path__ + "static/media/discoverImg3.b5e348a6.jpg";